var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"mb-4",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"outlined":""},scopedSlots:_vm._u([{key:"id",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.id))])]}},{key:"name",fn:function(ref){
var item = ref.item;
return [_c('b-button',{staticClass:"pl-0",attrs:{"variant":"link","to":{
            name: 'project-construction-type-edit',
            params: {
              id: item.id
            }
          }}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])]}},{key:"actions",fn:function(ref){
          var item = ref.item;
          var index = ref.index;
return [_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.handleDelete(item.id, index)}}},[_vm._v("\n          削除\n        ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }